import { Route } from '@angular/router'
import { TaxonomyDetailComponent } from '../taxonomy-detail/taxonomy-detail.component'
import { createTaxonomyDefinition } from '../taxonomy-detail/taxonomy.definition'

import { PermissionGuard } from '../../abacus/guards/permission.guard'
import { AuthGuard } from '../../abacus/guards/auth.guard'

import { TargetGroupListComponent } from './target-group-list/target-group-list.component'

export const targetGroupRoutes: Route[] = [
  {
    path: 'target-groups',
    component: TargetGroupListComponent,
    canActivate: [AuthGuard, PermissionGuard],
    data: {
      permission: 'browseTaxonomies'
    }
  },
  {
    path: 'target-groups/:id/edit',
    redirectTo: 'target-groups/:id',
    pathMatch: 'full'
  },
  {
    path: 'target-groups/:id',
    component: TaxonomyDetailComponent,
    canActivate: [AuthGuard, PermissionGuard],
    data: {
      definition: createTaxonomyDefinition({
        className: 'TargetGroup',
        nameSingular: 'Target Group',
        namePlural: 'Target Groups',
        path: 'target-groups',
        slug: 'taxonomies/target-groups',
        title: 'Target Groups'
      }),
      permission: 'readTaxonomies'
    }
  }
]
